/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { usePostHog } from '@posthog/react';
// import { setCurrentUser } from "../store/actions/authActions.js";
import { Button, Checkbox, Modal } from "flowbite-react";
import { NavLink } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { useRef } from "react";
import TableSearchBar from "../../components/TableSearchBar";
import instance, {
  fetchAllDepartments,
  fetchInitialResponseDueDate,
} from "../../api/api";
import { initFlowbite } from "flowbite";
import {
  getLikelihoodName,
  getLikelihoodValues,
} from "../../constants/likelihoodValues";
import { getConsequenceValues } from "../../constants/consequenceValues";
import { Loader } from "../../components/Loader";
import PerspectiveBadge from "../../components/PerspectiveBadge";
import { getControlEffectivenessValues } from "../../constants/controlEffectivenessValues";
import { useTenant } from "../../context/Tenant/TenantContext";

import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
  getSortedRowModel,
  SortingState,
} from "@tanstack/react-table";

type Risk = {
  id: string;
  riskRegisterId: string;
  riskNumber: string;
  riskName: string;
  perspective: string;
  objective: string;
  source: string;
  description: string;
  rootCause: string;
  likeLihoodValue: number;
  likeLihoodValueScore: number;
  riskConsequenceValue: number;
  riskConsequenceValueScoreAverage: number;
  controlEffectivenessScore: number;
  inherentRiskScore: number;
  residualRiskScore: number;
  likeLihoodComment: string;
  riskConsequenceValueScore: number;
  riskConsequenceComment: string;
  controlEffectiveness: string;
  likeLihoodValueScoreAverage: number;
  controlEffectivenessScoreAverage: number;
};

function AdminRiskAssessment() {
  const posthog = usePostHog();
  const { config } = useTenant();
  const [moveRisksModal, setMoveRisksModal] = useState(false);
  const [moreDetailsRequested, setMoreDetailsRequested] = useState(false);

  const handleMoreDetailsRequest = () => {
    setMoreDetailsRequested(!moreDetailsRequested);
  };

  const [currentRiskDetails, setCurrentRiskDetails] = useState<any>([]);
  const [isLoadingRisks, setIsLoadingRisks] = useState(false);
  const [allRisks, setAllRisks] = useState<any[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false);

  const [isApprovingRisks, setIsApprovingRisks] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [searchTerm, setSearchTerm] = useState("");
  const [sorting, setSorting] = useState<SortingState>([
    { id: "riskNumber", desc: false },
  ]);

  const [dueDate, setDueDate] = useState<any>(null);
  const [departments, setDepartments] = useState<any[]>([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedRiskIds, setSelectedRiskIds] = useState<string[]>([]);
  const [allVotes, setAllVotes] = useState<any[]>([]);

  const editDrawerRef = useRef<any>(null);

  // const [missingValuesError, setMissingValuesError] = useState("");

  const closeDrawerRef = useRef<any>(null);
  const [highlightedRiskId, setHighlightedRiskId] = useState<any>(null);

  const formatDate = (date: any) => {
    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, "0");
    const day = `${d.getDate()}`.padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const fetchDueDate = async () => {
      const theDueDate = await fetchInitialResponseDueDate();
      setDueDate(formatDate(theDueDate ? theDueDate : new Date()));
    };

    fetchDueDate();
    const fetchDepartments = async () => {
      setDepartments(await fetchAllDepartments());
    };
    fetchDepartments();
    posthog.capture('page_viewed', { page: 'admin_assessment_finalization' });
  }, []);

  const getAllRisks = async () => {
    try {
      setIsLoadingRisks(true);
      let assessmentResponse;

      const riskRegistryResponse = await instance.get(
        "/api/admin/riskRegister/riskRegisters/selections/SELECTION_COMPLETE"
      );

      if (selectedDepartment === "" || selectedDepartment === "All") {
        assessmentResponse = await instance.get(
          "/api/admin/riskAssessment/riskAssessments/all/APPROVED_FOR_ACTION"
        );
      } else {
        assessmentResponse = await instance.get(
          `/api/admin/riskAssessment/riskAssessments?departmentName=${selectedDepartment}`
        );
      }

      let riskResponses: any;
      try {
        const riskResponse = await instance.get(
          "/api/admin/riskResponse/riskResponses/all"
        );
        riskResponses =
          riskResponse && riskResponse.data ? riskResponse.data.data : [];
      } catch (error: any) {
        if (error.response && error.response.status === 404) {
          console.warn("Risk responses not found, continuing without them.");
        } else {
          throw error;
        }
      }

      const riskAssessmentAveragesResponse = await instance.get(
        "/api/admin/riskAssessment/riskAssessments/all/APPROVED_FOR_ACTION"
      );

      const riskRegister = riskRegistryResponse.data.data;
      const riskAssessments = assessmentResponse.data.data;
      const riskAssessmentAverages =
        riskAssessmentAveragesResponse.data.averages;
      setIsLoadingRisks(false);
      initFlowbite();

      const combinedRisks = riskAssessments
        .filter((assessment: any) =>
          riskRegister.some(
            (register: any) => register.id === assessment.riskRegisterId
          )
        )
        .map((assessment: any) => {
          const registers = riskRegister.find(
            (register: any) => register.id === assessment.riskRegisterId
          );

          return {
            ...assessment,
            riskNumber: registers.riskNumber,
            assessmentId: assessment.id,
            riskName: registers.riskName,
            perspective: registers.perspective,
            objective: registers.objective,
            source: registers.source,
            description: registers.description,
            rootCause: registers.rootCause,
          };
        });

      // Deduplicate by riskNumber
      const uniqueCombinedRisks = combinedRisks.filter(
        (risk: any, index: number, self: any[]) =>
          self.findIndex((r: any) => r.riskNumber === risk.riskNumber) === index
      );

      // Filter out risks that are present in riskResponse
      const filteredRisks = uniqueCombinedRisks.filter((risk: any) =>
        riskResponses
          ? !riskResponses.some(
              (response: any) => response.riskRegisterId === risk.riskRegisterId
            )
          : uniqueCombinedRisks
      );

      setAllRisks(uniqueCombinedRisks);

      if (riskAssessmentAverages) {
        const risksWithAverages = filteredRisks.map((risk: any) => {
          const averages = riskAssessmentAverages.find(
            (average: any) => average.id === risk.id
          );

          return {
            ...risk,
            likeLihoodValueScoreAverage: averages
              ? averages._avg.likeLihoodValueScore
              : 0,
            riskConsequenceValueScoreAverage: averages
              ? averages._avg.riskConsequenceValueScore
              : 0,
          };
        });

        setAllRisks(risksWithAverages);
      }
    } catch (error) {
      setIsLoadingRisks(false);
      console.error(error);
    }
  };
  useEffect(() => {
    getAllRisks();

    const getVotes = async () => {
      try {
        if (!currentRiskDetails?.riskRegisterId) return; // Guard against undefined
        const response = await instance.get(
          `/api/admin/votes/risk/${currentRiskDetails.riskRegisterId}`
        );
        setAllVotes(response.data.data.riskAssessments);
      } catch (error) {
        console.error("Error fetching votes:", error);
      }
    };
    getVotes();
  }, [selectedDepartment]);

  // Fetch votes when a specific risk drawer is opened
  useEffect(() => {
    const fetchVotesForRisk = async () => {
      try {
        if (!currentRiskDetails?.riskRegisterId) return;
        const response = await instance.get(
          `/api/admin/votes/risk/${currentRiskDetails.riskRegisterId}`
        );
        setAllVotes(response.data?.data?.riskAssessments || []);
      } catch (e) {
        console.error("Error fetching votes:", e);
        setAllVotes([]);
      }
    };

    if (isEditDrawerOpen) {
      fetchVotesForRisk();
    }
  }, [isEditDrawerOpen, currentRiskDetails?.riskRegisterId]);

  // A row is complete if all required fields are present and non-empty
  const isRiskComplete = (risk: Risk) =>
    Boolean(
      risk.likeLihoodValue &&
        risk.likeLihoodComment &&
        risk.likeLihoodComment.trim() !== "" &&
        risk.riskConsequenceValue &&
        risk.riskConsequenceComment &&
        risk.riskConsequenceComment.trim() !== "" &&
        risk.controlEffectivenessScore &&
        risk.controlEffectiveness &&
        risk.controlEffectiveness.trim() !== ""
    );

  const toggleSelect = (id: string) => {
    const risk = allRisks.find((r) => r.id === id);
    if (!risk || !isRiskComplete(risk)) return;
    setSelectedRiskIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleOpenEditDrawer = (riskId: string) => {
    const risk = allRisks.find((risk: Risk) => risk.id === riskId);
    setIsEditDrawerOpen(true);
    setCurrentRiskDetails(risk);
    setHighlightedRiskId(riskId);
  };

  const handleEditRiskAssessment = async (e: any) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await instance.post(
        `/api/employee/riskAssessment/create/${currentRiskDetails.riskRegisterId}`,
        {
          likeLihoodValue: currentRiskDetails.likeLihoodValue,
          likeLihoodValueScore: Number(currentRiskDetails.likeLihoodValue),
          likeLihoodComment: currentRiskDetails.likeLihoodComment
            ? currentRiskDetails.likeLihoodComment
            : "",
          riskConsequenceValue: currentRiskDetails.riskConsequenceValue,
          riskConsequenceValueScore: Number(
            currentRiskDetails.riskConsequenceValue
          ),
          riskConsequenceComment: currentRiskDetails.riskConsequenceComment
            ? currentRiskDetails.riskConsequenceComment
            : "",
          controlEffectiveness: currentRiskDetails.controlEffectiveness
            ? currentRiskDetails.controlEffectiveness
            : "",
          controlEffectivenessScore: Number(
            currentRiskDetails.controlEffectivenessScore
          ),
        }
      );
      posthog.capture('admin_assessment_edited', { riskId: currentRiskDetails.riskRegisterId });
      if (closeDrawerRef.current) {
        closeDrawerRef.current.click();
      }
      setIsSubmitting(false);
      await getAllRisks();
    } catch (error) {
      setIsSubmitting(false);
      return error;
    }
  };

  // const handleAddRiskLikelihoodComment = async (e) => {
  //   e.preventDefault();
  //   setIsSubmitting(true);
  //   try {
  //     await instance.post(
  //       `/api/employee/riskAssessment/create/${currentRiskDetails.riskRegisterId}`,
  //       {
  //         likeLihoodComment: currentRiskDetails.likeLihoodComment
  //           ? currentRiskDetails.likeLihoodComment
  //           : "",
  //       }
  //     );

  //     if (closeEditLikelihoodDrawerRef.current) {
  //       closeEditLikelihoodDrawerRef.current.click();
  //     }
  //     setIsSubmitting(false);
  //     window.location.reload();
  //   } catch (error) {
  //     setIsSubmitting(false);
  //     return error;
  //   }
  // };

  // const handleAddRiskConsequenceComment = async (e) => {
  //   e.preventDefault();
  //   setIsSubmitting(true);
  //   try {
  //     await instance.post(
  //       `/api/employee/riskAssessment/create/${currentRiskDetails.id}`,
  //       {
  //         riskConsequenceComment: currentRiskDetails.riskConsequenceComment
  //           ? currentRiskDetails.riskConsequenceComment
  //           : "",
  //       }
  //     );
  //     if (closeEditConsequenceCommentDrawerRef.current) {
  //       closeEditConsequenceCommentDrawerRef.current.click();
  //     }
  //     setIsSubmitting(false);
  //     window.location.reload();
  //   } catch (error) {
  //     setIsSubmitting(false);
  //     return error;
  //   }
  // };

  // const handleAddControlEffectiveness = async (e) => {
  //   e.preventDefault();
  //   setIsSubmitting(true);
  //   try {
  //     await instance.post(
  //       `/api/employee/riskAssessment/create/${currentRiskDetails.id}`,
  //       {
  //         controlEffectiveness: currentRiskDetails.controlEffectiveness
  //           ? currentRiskDetails.controlEffectiveness
  //           : "",
  //       }
  //     );
  //     if (closeEditControlEffectivenessDrawerRef.current) {
  //       closeEditControlEffectivenessDrawerRef.current.click();
  //     }
  //     setIsSubmitting(false);
  //     window.location.reload();
  //   } catch (error) {
  //     setIsSubmitting(false);
  //     return error;
  //   }
  // };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        editDrawerRef.current &&
        !editDrawerRef.current.contains(event.target)
      ) {
        setIsEditDrawerOpen(false);
        setHighlightedRiskId(null);
      }
    };
    if (isEditDrawerOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      setHighlightedRiskId(null);
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEditDrawerOpen]);

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  // Calculate the items to display based on the current page and items per page
  const paginatedRisks = React.useMemo(() => {
    let risksToDisplay = allRisks;

    // Only show risks that are fully complete (all scores AND comments filled)
    risksToDisplay = risksToDisplay.filter((risk: any) => isRiskComplete(risk));

    // Apply search filter
    if (searchTerm) {
      risksToDisplay = risksToDisplay.filter((risk: any) =>
        Object.values(risk).some((value) =>
          String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return risksToDisplay.slice(indexOfFirstItem, indexOfLastItem);
  }, [allRisks, currentPage, itemsPerPage, searchTerm]);

  const totalPages = Math.ceil(
    allRisks.filter((risk: any) => isRiskComplete(risk)).length / itemsPerPage
  );

  // useEffect(() => {
  //   const riskWithMissingValues = paginatedRisks.filter(
  //     (risk) =>
  //       !risk.likeLihoodValue ||
  //       !risk.likeLihoodComment ||
  //       risk.likeLihoodComment.trim() === "" ||
  //       !risk.riskConsequenceValue ||
  //       !risk.riskConsequenceComment ||
  //       risk.riskConsequenceComment.trim() === "" ||
  //       !risk.controlEffectivenessScore ||
  //       !risk.controlEffectiveness ||
  //       risk.controlEffectiveness.trim() === ""
  //   );

  //   if (riskWithMissingValues.length > 0) {
  //     setMissingValuesError("Some risks have missing values! These risks won't be moved to the next stage.")
  //   }
  //   setIsApprovingRisks(false);
  //   return;
  // }, [paginatedRisks]);

  const handleMoveRisksToNextStage = async () => {
    setIsApprovingRisks(true);
    try {
      for (const risk of allRisks) {
        if (
          risk.likeLihoodValueScore !== null &&
          risk.likeLihoodValue !== "" &&
          risk.riskConsequenceValueScore !== null &&
          risk.riskConsequenceValue !== "" &&
          risk.controlEffectivenessScore !== null &&
          risk.controlEffectiveness !== ""
        ) {
          await instance.put(
            `/api/admin/riskAssessment/update/status/${risk.assessmentId}`,
            {
              status: "ASSESSMENT_COMPLETED",
            }
          );

          await instance.post(
            `/api/employee/riskResponse/create/${risk.riskRegisterId}`,
            {
              riskConsequence: "--",
              responseText: "--",
              status: "ASSESSMENT_COMPLETED",
            }
          );
        }
      }

      if (dueDate) {
        await instance.post(
          `/api/admin/riskDuedate/riskDuedates/create/ASSESSMENT_COMPLETED`,
          {
            riskStatus: "ASSESSMENT_COMPLETED",
            dueDate: dueDate,
          }
        );
      } else {
        await instance.post(
          `/api/admin/riskDuedate/riskDuedates/create/ASSESSMENT_COMPLETED`,
          {
            riskStatus: "ASSESSMENT_COMPLETED",
          }
        );
      }

      await instance.post("/api/admin/emails/stage-kickoff ", {
        stageName: "Risk Response Entry",
        role: "EMPLOYEE",
        riskStatus: "ASSESSMENT_COMPLETED",
      });

      posthog.capture('admin_assessment_finalized', { risksCount: allRisks.length });
      setIsApprovingRisks(false);
      window.location.reload();
    } catch (error) {
      setIsApprovingRisks(false);
      console.error(error);
    }
  };

  const columnHelper = createColumnHelper<Risk>();
  const columns = [
    columnHelper.accessor("riskNumber", {
      header: () => <span className="whitespace-nowrap">Risk Number</span>,
      cell: (info) => {
        const id = info.row.original.id;
        const complete = isRiskComplete(info.row.original);
        return (
          <span className="whitespace-nowrap font-bold">
            <span className="mr-2">
              {complete && (
                <Checkbox
                  aria-label="Select risk"
                  className={`h-4 w-4 ${
                    complete ? "" : "opacity-50 cursor-not-allowed"
                  }`}
                  checked={selectedRiskIds.includes(id)}
                  onChange={() => toggleSelect(id)}
                />
              )}
            </span>
            {info.getValue()}
          </span>
        );
      },
    }),
    columnHelper.accessor("riskName", {
      header: () => <span className="whitespace-nowrap">Risk Name</span>,
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor((row) => row.perspective, {
      id: "perspective",
      cell: (info) => <PerspectiveBadge value={info.getValue()} />,
      header: () => <span>Perspective</span>,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("objective", {
      header: () => "Objective",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("likeLihoodValue", {
      header: () => "Likelihood Value",
      cell: (info) => (
        <div className="flex flex-col h-full justify-between gap-10 whitespace-nowrap">
          <div className="h-full">
            {info.getValue()}{" "}
            {getLikelihoodName(info.row.original.likeLihoodValue, config) || (
              <span className="text-red italic">{"- Required -"}</span>
            )}
          </div>
          <div className="font-bold h-full text-gray-500">
            Average Value:{" "}
            {info.row.original.likeLihoodValueScoreAverage
              ? info.row.original.likeLihoodValueScoreAverage
              : 0}
          </div>
        </div>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("riskConsequenceValue", {
      header: () => "Risk Consequence Value",
      cell: (info) => (
        <div className="flex flex-col h-full justify-between gap-10 whitespace-nowrap">
          <div className="h-full">
            {info.getValue()}{" "}
            {getLikelihoodName(info.row.original.riskConsequenceValue, config) || (
              <span className="text-red italic">{"- Required -"}</span>
            )}
          </div>
          <div className="font-bold h-full text-gray-500">
            Average Value:{" "}
            {info.row.original.riskConsequenceValueScoreAverage
              ? info.row.original.riskConsequenceValueScoreAverage
              : 0}
          </div>
        </div>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("controlEffectivenessScore", {
      header: () => "Control Strength",
      cell: (info) => (
        <div className="flex flex-col h-full justify-between gap-10 whitespace-nowrap">
          <div className="h-full">
            {info.getValue()}{" "}
            {getLikelihoodName(info.row.original.controlEffectivenessScore, config) || (
              <span className="text-red italic">{"- Required -"}</span>
            )}
          </div>
          <div className="font-bold h-full text-gray-500">
            Average Value:{" "}
            {info.row.original.controlEffectivenessScoreAverage
              ? info.row.original.controlEffectivenessScoreAverage
              : 0}
          </div>
        </div>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("likeLihoodComment", {
      header: () => "Likelihood Comment",
      cell: (info) => (
        <div className="">
          {info.getValue() || (
            <span className="text-red italic">{"- Required -"}</span>
          )}
        </div>
      ),
      footer: (info) => info.column.id,
    }),
    
    columnHelper.accessor("riskConsequenceComment", {
      header: () => "Risk Consequence Comment",
      cell: (info) => (
        <div className="">
          {info.getValue() || (
            <span className="text-red italic">{"- Required -"}</span>
          )}
        </div>
      ),
      footer: (info) => info.column.id,
    }),
    
    columnHelper.accessor("controlEffectiveness", {
      header: () => "Control Effectiveness",
      cell: (info) => (
        <div className="">
          {info.getValue() || (
            <span className="text-red italic">{"- Required -"}</span>
          )}
        </div>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.display({
      id: "actions",
      header: () => <span>Actions</span>,
      cell: ({ row }) => (
        <button
          type="button"
          className="w-auto flex justify-center text-caribbeanCurrent items-center hover:text-black hover:bg-white hover:border-2 hover:border-caribbeanCurrent border border-caribbeanCurrent hover:bg-caribbeanCurrent focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-4 py-2 text-center inline-flex me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-caribbeanCurrent dark:focus:ring-blue-800 border-caribbeanCurrent text-black hover:bg-blue-800 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          data-drawer-target="drawer-edit-risk"
          data-drawer-show="drawer-edit-risk"
          data-drawer-placement="right"
          aria-controls="drawer-edit-risk"
          onClick={() => handleOpenEditDrawer(row.original.id)}
        >
          <svg
            className="w-4 h-4 text-white-800 dark:text-white me-2"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
            />
          </svg>
          Edit
        </button>
      ),
    }),
  ];

  const table = useReactTable<Risk>({
    data: paginatedRisks,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    
    state: {
      sorting,
    },
    onSortingChange: setSorting,
  });

  return (
    <>
      {/* <!-- Breadcrumb --> */}
      <nav
        className="justify-between  py-3 text-gray-700  sm:flex bg-gray-50"
        aria-label="Breadcrumb"
      >
        <ol className="inline-flex items-center mb-3 space-x-1 md:space-x-2 rtl:space-x-reverse sm:mb-0">
          <li>
            <div className="flex items-center">
              <NavLink
                to=""
                className=" text-sm font-medium text-gray-700 hover:text-blue-600  dark:text-gray-400 dark:hover:text-white"
              >
                Risk Assessment
              </NavLink>
            </div>
          </li>

          <li aria-current="page">
            <div className="flex items-center ">
              <svg
                className="rtl:rotate-180 w-3 h-3 mx-1 text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span className="mx-1 text-sm font-medium text-gray-500 md:mx-2 dark:text-gray-400">
                Assessment Finalization
              </span>
            </div>
          </li>
        </ol>
      </nav>
      <h1 className="text-xl mb-3 font-semibold text-gray-700">
        Assessment Finalization
      </h1>

      {/* <p className="text-caribbeanCurrent font-semibold">
        Due date: 14 September, 2024
      </p> */}
      <form className="flex max-w-sm my-4 justify-center items-center">
        <label
          htmlFor="countries"
          className="block mb-2 text-md font-medium text-gray-900 dark:text-white"
        >
          Department
        </label>
        <select
          id="countries"
          className="ml-5 bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          onChange={(e) => setSelectedDepartment(e.target.value)}
        >
          <option>All</option>
          {departments &&
            departments.map((department, index) => (
              <option key={index}>{department.name}</option>
            ))}
        </select>
      </form>

      <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 mb-4">
        <div className="p-5 text-lg font-semibold text-left rtl:text-right text-gray-900 bg-white dark:text-white dark:bg-gray-800 sticky top-0 z-20">
          <div className="w-full flex items-center justify-between">
            <p>Department Risks</p>
            <div className="flex flex-row gap-4 items-center justify-center">
              <div className="">
                <TableSearchBar
                  searchTerm={searchTerm}
                  onSearchChange={setSearchTerm}
                  placeholder="Search risks..."
                />
              </div>
            </div>
          </div>
        </div>
        <div className="rt-wrap relative sm:rounded-lg max-h-[calc(100vh-300px)] overflow-y-auto">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-sm text-jet font-bold bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky top-0 z-10">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                    const isSorted = header.column.getIsSorted();
                    const isActionsColumn = header.column.id === "actions";
                    return (
                      <th
                        scope="col"
                        key={header.id}
                        className={`px-6 py-3 ${
                          isActionsColumn
                            ? "sticky right-0 bg-gray-50 dark:bg-gray-700 z-10"
                            : ""
                        }`}
                        aria-sort={
                          isSorted === "asc"
                            ? "ascending"
                            : isSorted === "desc"
                            ? "descending"
                            : "none"
                        }
                      >
                        {header.isPlaceholder ? null : (
                          <button
                            type="button"
                            className={`flex items-center gap-1 select-none ${
                              header.column.getCanSort()
                                ? "cursor-pointer"
                                : "cursor-default"
                            }`}
                            onClick={header.column.getToggleSortingHandler()}
                            title={
                              header.column.getCanSort() ? "Sort" : undefined
                            }
                          >
                            {flexRender(
                              header.column.columnDef.header,
                              header.getContext()
                            )}
                            {header.column.getCanSort() && (
                              <span className="text-xs">
                                {isSorted === "asc"
                                  ? "▲"
                                  : isSorted === "desc"
                                  ? "▼"
                                  : "⇅"}
                              </span>
                            )}
                          </button>
                        )}
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>

            {isLoadingRisks ? (
              <tbody>
                <tr className="text-center">
                  <td colSpan={7} className="text-center">
                    <div className="flex justify-center items-center h-96">
                      <Loader size={"xl"} />
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody className="text-jet font-medium text-xs">
                {table.getRowModel().rows.map((row) => (
                  <tr
                    key={row.id}
                    className={`bg-gray border-b hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 ${
                      highlightedRiskId === row.original.id ? "bg-gray-200" : ""
                    }`}
                  >
                    {row.getVisibleCells().map((cell) => {
                      const isActionsColumn = cell.column.id === "actions";
                      return (
                        <td
                          className={`px-6 py-4 align-top ${
                            isActionsColumn
                              ? "sticky right-0 bg-white dark:bg-gray-800"
                              : ""
                          }`}
                          key={cell.id}
                        >
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            )}
          </table>
          {/* Pagination */}
          <div className="mt-4 pl-10 pr-10 pb-5 text-jet font-medium text-xs">
            <nav aria-label="Page navigation">
              <ul className="flex justify-between">
                <li className="flex flex-row items-center">
                  <div>
                    <p>Show rows per page</p>
                  </div>
                  <div>
                    <select
                      className="ml-2 bg-gray-50 border border-caribbeanCurrent text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      onChange={(e) => setItemsPerPage(Number(e.target.value))}
                    >
                      <option>25</option>
                      <option>50</option>
                      <option>100</option>
                    </select>
                  </div>
                </li>
                <li className="flex flex-row gap-1 items-center text-gray-500">
                  <div>
                    <p>
                      {currentPage} of {totalPages === 0 ? 1 : totalPages}
                    </p>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg rounded-r-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      {"<"}
                    </button>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      {">"}
                    </button>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/* score risk */}
      {allRisks.length > 0 && (
        <div
          id="drawer-edit-risk"
          ref={editDrawerRef}
          className={`fixed top-0 right-0 z-50 h-screen p-4 overflow-y-auto transition-transform ${
            isEditDrawerOpen ? "translate-x-0" : "translate-x-full"
          } bg-white w-full md:w-1/4 dark:bg-gray-800`}
          tabIndex={-1}
          aria-labelledby="drawer-edit-risk-label"
        >
          <h5
            id="drawer-label"
            className="inline-flex items-center mb-6 text-base font-semibold text-gray-500  dark:text-gray-400"
          >
            Assessment Risk Scoring
          </h5>
          <p className="text-sm my-4 text-gray-400">
            You are about to review a risk, please keep it professional
          </p>
          <button
            type="button"
            data-drawer-hide="drawer-edit-risk"
            aria-controls="drawer-edit-risk"
            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
            ref={closeDrawerRef}
            onClick={() => setIsEditDrawerOpen(false)}
          >
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close menu</span>
          </button>
          <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600  mb-4 p-4">
            <div className="mb-6">
              <label
                htmlFor="perspective"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Perspective
              </label>
              <input
                type="text"
                id="perspective"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Perspective goes here"
                required
                disabled
                readOnly
                value={currentRiskDetails.perspective}
              />
            </div>
            <div className="mb-6">
              <label
                htmlFor="riskGoals"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Objective
              </label>
              <input
                type="text"
                id="objective"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Objective goes here"
                required
                disabled
                readOnly
                value={currentRiskDetails.objective}
              />
            </div>
            <div className="mb-6">
              <label
                htmlFor="riskName"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Name
              </label>
              <input
                type="text"
                id="riskName"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Risk title goes here"
                required
                disabled
                readOnly
                value={currentRiskDetails.riskName}
              />
            </div>
            {moreDetailsRequested && (
              <>
                <div className="mb-6">
                  <label
                    htmlFor="source"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Source
                  </label>
                  <input
                    type="text"
                    id="source"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Risk title goes here"
                    required
                    disabled
                    readOnly
                    value={currentRiskDetails.source}
                  />
                </div>
                <div className="mb-6">
                  <label
                    htmlFor="description"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Description
                  </label>
                  <textarea
                    readOnly
                    id="description"
                    rows={4}
                    disabled
                    className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder=""
                    value={currentRiskDetails.description}
                  ></textarea>
                </div>
                <div className="mb-6">
                  <label
                    htmlFor="rootCauses"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Root Causes
                  </label>
                  <textarea
                    id="rootCauses"
                    readOnly
                    rows={4}
                    className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder=""
                    disabled
                    value={currentRiskDetails.rootCause}
                  ></textarea>
                </div>
              </>
            )}
            <div className="flex justify-center">
              <button
                onClick={handleMoreDetailsRequest}
                className="text-center font-bold text-caribbeanCurrent flex items-center"
              >
                {moreDetailsRequested ? (
                  <>
                    Collapse{" "}
                    <span>
                      <IoIosArrowDown />
                    </span>
                  </>
                ) : (
                  <>
                    See More Details{" "}
                    <span>
                      <IoIosArrowDown />
                    </span>
                  </>
                )}
              </button>
            </div>
          </div>
          <form
            onSubmit={handleEditRiskAssessment}
            className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600  mb-4 p-4"
          >
            <div className="">
              <label
                htmlFor="riskLikelihoodValue"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Likelihood Value
              </label>
              <select
                id="riskLikelihoodValue"
                className="bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                defaultValue={
                  currentRiskDetails && currentRiskDetails.likeLihoodValue
                    ? currentRiskDetails.likeLihoodValue
                    : ""
                }
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    likeLihoodValue: e.target.value,
                  }));
                }}
                value={
                  currentRiskDetails && currentRiskDetails.likeLihoodValue
                    ? currentRiskDetails.likeLihoodValue
                    : ""
                }
              >
                <option>0 Rating</option>
                {getLikelihoodValues(config).map(([score, name]) => (
                  <option value={score} key={score}>
                    {score} {name}
                  </option>
                ))}
              </select>
            </div>
            <details className="mb-6">
              <summary className="cursor-pointer px-2 py-1 font-medium">
                Votes ({allVotes?.length || 0})
              </summary>
              <ul className="mt-2 px-2">
                {allVotes?.length ? (
                  allVotes.map((v: any) => (
                    <li
                      key={v.id}
                      className="flex justify-between py-1 border-b last:border-b-0"
                    >
                      <span className="text-gray-700">
                        {`${v.User?.firstName ?? ""} ${
                          v.User?.lastName ?? ""
                        }`.trim() ||
                          v.User?.email ||
                          "Unknown"}
                      </span>
                      <span className="font-semibold">
                        {v.likeLihoodValueScore ?? "-"}
                      </span>
                    </li>
                  ))
                ) : (
                  <li className="text-gray-400">No votes yet.</li>
                )}
              </ul>
            </details>

            <div className="mb-6">
              <label
                htmlFor="Likelihood"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Likelihood Comment
              </label>
              <textarea
                id="Likelihood"
                rows={4}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Risk likelihood comment here"
                defaultValue={
                  currentRiskDetails && currentRiskDetails.likeLihoodComment
                    ? currentRiskDetails.likeLihoodComment
                    : ""
                }
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    likeLihoodComment: e.target.value,
                  }));
                }}
              ></textarea>
            </div>

            <div className="">
              <label
                htmlFor="potentialImpact "
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Consequence Value
              </label>
              <select
                id="riskConsequenceValue"
                className="bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                defaultValue={
                  currentRiskDetails && currentRiskDetails.riskConsequenceValue
                    ? currentRiskDetails.riskConsequenceValue
                    : ""
                }
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    riskConsequenceValue: e.target.value,
                  }));
                }}
                value={
                  currentRiskDetails && currentRiskDetails.riskConsequenceValue
                    ? currentRiskDetails.riskConsequenceValue
                    : ""
                }
              >
                <option>0 Rating</option>
                {getConsequenceValues(config).map(([score, name]) => (
                  <option value={score} key={score}>
                    {score} {name}
                  </option>
                ))}
              </select>
            </div>
            <details className="mb-6">
              <summary className="cursor-pointer px-2 py-1 font-medium">
                Votes ({allVotes?.length || 0})
              </summary>
              <ul className="mt-2 px-2">
                {allVotes?.length ? (
                  allVotes.map((v: any) => (
                    <li
                      key={v.id}
                      className="flex justify-between py-1 border-b last:border-b-0"
                    >
                      <span className="text-gray-700">
                        {`${v.User?.firstName ?? ""} ${
                          v.User?.lastName ?? ""
                        }`.trim() ||
                          v.User?.email ||
                          "Unknown"}
                      </span>
                      <span className="font-semibold">
                        {v.riskConsequenceValueScore ?? "-"}
                      </span>
                    </li>
                  ))
                ) : (
                  <li className="text-gray-400">No votes yet.</li>
                )}
              </ul>
            </details>

            <div className="mb-6">
              <label
                htmlFor="potentialImpact "
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Consequence Comment
              </label>
              <textarea
                id="potentialImpact"
                rows={4}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Risk consequence comment here..."
                defaultValue={
                  currentRiskDetails &&
                  currentRiskDetails.riskConsequenceComment
                    ? currentRiskDetails.riskConsequenceComment
                    : ""
                }
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    riskConsequenceComment: e.target.value,
                  }));
                }}
              ></textarea>
            </div>

            <div className="">
              <label
                htmlFor="riskConsequenceValue"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Control Strength
              </label>
              <select
                id="controlStrength"
                className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                defaultValue={
                  currentRiskDetails &&
                  currentRiskDetails.controlEffectivenessScore
                    ? currentRiskDetails.controlEffectivenessScore
                    : ""
                }
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    controlEffectivenessScore: e.target.value,
                  }));
                }}
                value={
                  currentRiskDetails &&
                  currentRiskDetails.controlEffectivenessScore
                    ? currentRiskDetails.controlEffectivenessScore
                    : ""
                }
              >
                <option>0 Rating</option>
                {getControlEffectivenessValues(config).map(([score, name]) => (
                  <option value={score} key={score}>
                    {score} {name}
                  </option>
                ))}
              </select>
            </div>
            <details className="mb-6">
              <summary className="cursor-pointer px-2 py-1 font-medium">
                Votes ({allVotes?.length || 0})
              </summary>
              <ul className="mt-2 px-2">
                {allVotes?.length ? (
                  allVotes.map((v: any) => (
                    <li
                      key={v.id}
                      className="flex justify-between py-1 border-b last:border-b-0"
                    >
                      <span className="text-gray-700">
                        {`${v.User?.firstName ?? ""} ${
                          v.User?.lastName ?? ""
                        }`.trim() ||
                          v.User?.email ||
                          "Unknown"}
                      </span>
                      <span className="font-semibold">
                        {v.controlEffectivenessScore ?? "-"}
                      </span>
                    </li>
                  ))
                ) : (
                  <li className="text-gray-400">No votes yet.</li>
                )}
              </ul>
            </details>

            <div className="mb-6">
              <label
                htmlFor="currentControl"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Control Effectiveness
              </label>
              <textarea
                id="currentControl"
                rows={4}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Control effectiveness here..."
                defaultValue={
                  currentRiskDetails && currentRiskDetails.controlEffectiveness
                    ? currentRiskDetails.controlEffectiveness
                    : ""
                }
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    controlEffectiveness: e.target.value,
                  }));
                }}
              ></textarea>
            </div>

            <div className="flex gap-4">
              <button
                disabled={isSubmitting}
                type="submit"
                className={`justify-center items-center inline-flex text-white bg-caribbeanCurrent hover:bg-blue-800 w-full focus:ring-4 focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-caribbeanCurrent dark:hover:bg-caribbeanCurrent focus:outline-none dark:focus:ring-caribbeanCurrent block ${
                  isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                }`}
                data-drawer-placement="right"
              >
                {isSubmitting ? <Loader size="sm" /> : "Submit"}
              </button>

              <button
                onClick={(e) => {
                  e.preventDefault();
                  setIsEditDrawerOpen(false);
                }}
                className="justify-center items-center inline-flex text-black border-2 border-caribbeanCurrent hover:text-white hover:bg-caribbeanCurrent w-full focus:ring-4 focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-caribbeanCurrent dark:hover:bg-caribbeanCurrent focus:outline-none dark:focus:ring-caribbeanCurrent block"
                data-drawer-placement="right"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="border-red-300 dark:border-gray-600 h-54 mb-4">
        <div className="space-y-6">
          {/* <h3 className="text-riskRed font-medium text-lg">
            Move To Response Stage
          </h3> */}
          <Button
            onClick={() => setMoveRisksModal(true)}
            className="bg-riskRed font-bold"
            disabled={selectedRiskIds.length === 0}
          >
            Move Risks
          </Button>
          <Modal
            dismissible
            show={moveRisksModal}
            size="xl"
            onClose={() => setMoveRisksModal(false)}
            popup
          >
            {/* <Modal dismissible show={openModal} onClose={() => setOpenModal(false)}> */}
            <Modal.Header className="ml-3 p-5 border-b">
              <h4 className="font-bold text-gray-700 dark:text-gray-400">
                Move Risks To Next Stage
              </h4>
            </Modal.Header>
            <Modal.Body>
              <div className="space-y-5 p-3">
                <p className="text-base leading-relaxed text-gray-700 dark:text-gray-400">
                  Are you sure you want to promote these risks to the response
                  stage?
                </p>
                <p className="text-base leading-relaxed text-gray-700 dark:text-gray-400">
                  <span className="font-bold">Note: </span> You can't undo this
                  action
                </p>
                {/* {missingValuesError && <p className="text-red italic text-xs">
                ({missingValuesError})
                </p>} */}
              </div>
              {!dueDate && (
                <span className="space-y-5 p-3 text-red">
                  Please set a due date!
                </span>
              )}
            </Modal.Body>
            <Modal.Footer className="border-t">
              <Button
                color="gray"
                className="border-none text-riskRed"
                onClick={() => setMoveRisksModal(false)}
              >
                Cancel
              </Button>
              <Button
                className="bg-riskRed hover:bg-riskRed"
                disabled={!dueDate}
                onClick={() => {
                  handleMoveRisksToNextStage();
                }}
              >
                {isApprovingRisks ? <Loader size="sm" /> : "Confirm"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default AdminRiskAssessment;
